<div class="p-4 mt-5 mx-[60px] border border-l-4"
     [ngClass]="
     severity == Piano.SeverityChoices.ERROR ? 'bg-red-100 border-red-300 border-l-red-500':
     severity == Piano.SeverityChoices.WARNING ? 'bg-yellow-100 border-yellow-300 border-l-yellow-500' :
     severity == Piano.SeverityChoices.SUCCESS ? 'bg-green-100 border-green-300 border-l-green-500' :
      'bg-blue-100 border-blue-500 border-l-blue-500'">
   <div class="flex">
      <div class="flex-shrink-0">
         <svg *ngIf="severity == Piano.SeverityChoices.ERROR" class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
         </svg>

         <svg *ngIf="severity == Piano.SeverityChoices.WARNING" class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
         </svg>

<!--         <svg *ngIf="severity == Piano.SeverityChoices.SUCCESS" class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">-->
<!--            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" />-->
<!--         </svg>-->

      </div>
            <div class="ml-3 inline-flex w-full justify-between">
               <div>
                  <span class="font-bold">{{message}}</span>
                  <span class="ml-2">{{subMessage}}</span>
               </div>

               <div *ngIf="showCompletaRegistrazione"><div class="cursor-pointer text-blue-500 underline" (click)="clickCompleteRegister()">Completa la registrazione</div></div>
               <div *ngIf="showAggiornaPiano"><div class="cursor-pointer text-blue-500 underline" (click)="clickGoToAggiornaPiano()">Attiva Piano</div></div>
            </div>
   </div>
</div>
